<template>
    <span class="row">
        <nav v-if="lastPage > 1" class="pagination-nav">
            <ul class="pagination small-4 no-bullet" aria-label="Pagination">
                <li>
                    <button :class="{ 'is-disabled': page === 1 }"
                            :data-page="prevPage"
                            class="pagination-item previous  icon-arrow-left"
                            title="Page précédente"
                            type="button">
                        <span class="show-for-sr">Page précédente</span>
                    </button>
                </li>
                <li v-if="minPage(page) > 1">
                    <button type="button" :data-page="1" class="pagination-item" title="Page">
                        <span class="show-for-sr">Page</span> 1
                    </button>
                </li>
                <li v-if="minPage(page) > 2">
                    <span class="pagination-item is-disabled" title="&hellip;">&hellip;</span>
                </li>
                <li v-for="n in lowerPages(page, lastPage)">
                    <button type="button" :data-page="n" class="pagination-item" title="Page">
                        <span class="show-for-sr">Page</span> {{ n }}
                    </button>
                </li>
                <li>
                    <button type="button" :data-page="page" class="pagination-item is-current" title="Page">
                        <span class="show-for-sr">Page</span> {{ page }}
                    </button>
                </li>
                <li v-for="n in upperPages(page, lastPage)">
                    <button type="button" :data-page="n" class="pagination-item" title="Page">
                        <span class="show-for-sr">Page</span> {{ n }}
                    </button>
                </li>
                <li v-if="lastPage > parseInt(maxPage(page, lastPage)) + 1">
                    <span class="pagination-item is-disabled" title="&hellip;">&hellip;</span>
                </li>
                <li v-if="lastPage > maxPage(page, lastPage)">
                    <button type="button" :data-page="lastPage" class="pagination-item" title="Page">
                        <span class="show-for-sr">Page</span> {{ lastPage }}
                    </button>
                </li>
                <li>
                    <button :class="{ 'is-disabled': page === lastPage }"
                            :data-page="nextPage"
                            class="pagination-item next icon-arrow-left"
                            title="Page suivante"
                            type="button">
                        <span class="show-for-sr">Page suivante</span>
                    </button>
                </li>
            </ul>
        </nav>
        <div class="pagination-visible-items align-self-center">{{ page }}-{{ pageSize }} sur {{ totalHits }} articles</div>
    </span>
</template>

<script>
import {range} from 'lodash';

const delta = 2;

export default {
    props: [
        'initPage',
        'initLastPage',
        'initTotalHits',
        'initPageSize'
    ],
    data: function () {
        return {
            page: parseInt(this.initPage),
            lastPage: parseInt(this.initLastPage),
            prevPage: parseInt(this.initPage) - 1,
            nextPage: parseInt(this.initPage) + 1,
            pageSize: parseInt(this.initPageSize),
            originalPageSize: parseInt(this.initPageSize),
            totalHits: parseInt(this.initTotalHits),
            locked: false,
        };
    },
    methods: {
        update: function (page, lastPage, totalHits) {
            this.page = parseInt(page);
            this.lastPage = parseInt(lastPage);
            this.prevPage = parseInt(page) - 1;
            this.nextPage = parseInt(page) + 1;
            this.totalHits = totalHits;
            this.pageSize = totalHits < this.originalPageSize ? totalHits : this.originalPageSize;
        },
        minPage: function (page) {
            var minPage = Math.max(1, page - delta);
            if (minPage <= 1) {
                minPage = 1;
            }
            return minPage;
        },
        maxPage: function (page, lastPage) {
            var maxPage = Math.min(lastPage, page + delta);
            if (maxPage > lastPage) {
                maxPage = lastPage;
            }
            return maxPage;
        },
        lock: function () {
            this.locked = true;
            return this;
        },
        unLock: function () {
            this.locked = false;
            return this;
        },
        isLock() {
            return this.locked === true;
        },
        lowerPages: function (page) {
            return range(this.minPage(page), page);
        },
        upperPages: function (page, lastPage) {
            return range(parseInt(page) + 1, parseInt(this.maxPage(page, lastPage)) + 1);
        },
    },
};
</script>
